// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup-arrow[data-v-76bc9af3]{display:flex;justify-content:center;overflow:hidden;position:fixed;--arrowBg:#fff;z-index:11}.popup-arrow[data-v-76bc9af3]:after{background:var(--arrowBg);box-shadow:0 0 4px rgba(49,58,70,.38);content:\"\";display:block;height:23px;margin-top:6px;position:relative;transform:rotate(45deg);width:23px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
